<template>
  <header class="VB_Brochure_Header">
    <ViewmedicaBrochureLogo :image="logo" />
    <ViewmedicaBrochureContactInfo
      :contact="branding.address || branding.domain"
      :qr="branding.qr"
    />
    <div class="qrcode-vue" v-if="branding.qr">
      <qrcode-vue
        :value="`${shareBase}${client}/${language}/${file}`"
        :size="65"
        render-as="svg"
      ></qrcode-vue>
      <p>{{ $t("qr") || "See the Video" }}</p>
    </div>

    <ViewmedicaBrochureTitle />
  </header>
</template>

<script>
import { mapState } from "vuex";

import ViewmedicaBrochureContactInfo from "./ViewmedicaBrochureContactInfo.vue";
import ViewmedicaBrochureLogo from "./ViewmedicaBrochureLogo.vue";
import ViewmedicaBrochureTitle from "./ViewmedicaBrochureTitle.vue";
import QrcodeVue from "qrcode.vue";

export default {
  name: "ViewmedicaBrochureHeader",

  props: {
    logo: {
      required: true,
    },
  },

  components: {
    ViewmedicaBrochureContactInfo,
    ViewmedicaBrochureLogo,
    ViewmedicaBrochureTitle,
    QrcodeVue,
  },

  data() {
    return {
      shareBase: process.env.VUE_APP_SHARE_BASE_URL,
    };
  },

  computed: {
    ...mapState({
      branding: (s) => s.branding,
      client: (s) => s.route.params.client,
      language: (s) => s.route.params.language,
      file: (s) => s.route.params.file,
    }),
  },
};
</script>

<style>
.qrcode-vue {
  position: absolute;
  top: 6;
  right: 24pt;
  padding: 12pt 0 6pt 0;
  background: white;
  font-family: helvetica, arial, sans-serif;
  font-size: 6pt;
  font-weight: 700;
  line-height: 1.5;
  text-align: center;
}
</style>
